<template>
  <div style="background-color: #1867c0">
    <v-img :src="require('@/assets/banner-logomini.webp')" height="35" />
  </div>
  <!-- Footer -->
  <footer
    class="text-center text-lg-start text-white"
    style="
      background-color: #1867c0;
      font-family: Arial, Helvetica, sans-serif;"
  >
    <!-- Grid container -->
    <div class="container p-4 pb-0">
      <!-- Section: Links -->
      <section class="">
        <!--Grid row-->
        <div class="row">
          <!-- Grid column -->
          <div class="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
            <h6 align="center" class="text-uppercase mb-4 font-weight-bold">
              CASA CRU S.A. DE C.V.
            </h6>
            <v-img
              alt=""
              :src="require('@/assets/banner-logo.webp')"
              style="border-radius: 30px"
            />
          </div>
          <!-- Grid column -->

          <hr class="w-100 clearfix d-md-none" />

          <!-- Grid column -->
          <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3" align="center">
            <h6 class="text-uppercase mb-4 font-weight-bold">MENÚ</h6>
            <p>
              <a class="text-white rutas" href="/">INICIO</a>
            </p>
            <p>
              <a class="text-white rutas" href="/bloquera">BLOQUERA</a>
            </p>
            <p>
              <a class="text-white rutas" href="/portafolio">PORTAFOLIO</a>
            </p>
            <p>
              <a class="text-white rutas" href="/about">NOSOTROS</a>
            </p>
          </div>
          <!-- Grid column -->

          <hr class="w-100 clearfix d-md-none" />

          <!-- Grid column -->
          <hr class="w-100 clearfix d-md-none" />

          <!-- Grid column -->
          <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3" align="center">
            <h6  class="text-uppercase mb-4 font-weight-bold">CONTACTO</h6>
            <p>
              <i class="fas fa-home mr-3"></i>
              <span style="font-weight: 700;">Matriz:</span>
              Independencia SN, Col. Dengui,
              42840 San Miguel Vindho, Hgo.
            </p>
            <p><i class="fas fa-envelope mr-3"></i> <span style="font-weight: 700;">Email:</span> casacru87@gmail.com</p>
            <p><i class="fas fa-phone mr-3"></i><span style="font-weight: 700;">Tel:</span> (773) 785-1885</p>
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3" align="center">
            <h6 class="text-uppercase mb-4 font-weight-bold">Horario de Servicio</h6>

            <p><span style="font-weight: 700; font-family: Arial, Helvetica, sans-serif;">Lunes a Viernes:</span>  8:00 am a 17:00 pm</p>
            <p><span style="font-weight: 700; font-family: Arial, Helvetica, sans-serif;">Sabado:</span>  8:00 am a 13:00 pm</p>
          </div>
        </div>
        <!--Grid row-->
      </section>
      <!-- Section: Links -->
    </div>
    <!-- Grid container -->

    <!-- Copyright -->
    <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
      © 2023 Copyright
    </div>
    <!-- Copyright -->
  </footer>
  <!-- Footer -->
</template>

<script>
export default {};
</script>

<style scope>
.rutas {
  text-decoration: none;
}
</style>
